// --------------------------------------------------------------------------
// Autocomplete module that uses jquery-editable-select plugin
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

require('jquery-editable-select');

module.exports = function (options) {
    var ref = { $root: options.context };
    var state = {};

    function init() {
        var selector = ref.$root.data('autocomplete-selector');

        if (selector.length > 0) {
            ref.autcompleteElement = ref.$root.find(selector);

            ref.autcompleteElement.editableSelect({
                effects: 'fade'
            });
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/autocomplete.js
// module id = 508
// module chunks = 0